export const GOODS_REQUEST_NOTE = {
  BASE_PATH: "/goods-request/goods-request-note/",
  MAKE_ISSUE_PATH(id: string | number) {
    return this.BASE_PATH + `${id}` + "/edit/make-issue";
  },
  ADD_PATH() {
    return this.BASE_PATH + "add";
  },
  ADD_BUTTON_TITLE: "Add Goods Request Note",
  LIST_PAGE_TITLE: "Goods Request Note List",
  EDIT_PAGE_TITLE: "Edit Goods Request Note",
  GET_ALL: "goods-request/goods-request-note",
  GET_ALL_MAKE_PAYMENTS: "goods-request-note/payment",
  GET_ONE: "goods-request/goods-request-note/edit/",
  PRINT: "goods-request/goods-request-note/print/",
  CREATE: "goods-request/goods-request-note/create",
  UPDATE: "goods-request/goods-request-note/update/",
  DELETE: "goods-request/goods-request-note/delete/",
  DELETE_MAKE_PAYMENT: "goods-request/goods-request-note/payment/delete/",
  MAKE_PAYMENT: "goods-request/goods-request-note/payment/update/",
  ADD_NEW_TITLE: "Add New Goods Request Note",
};
